import detailsTemplate from './details.html';

export default angular
  .module('main.reports.view.tabs.details', [])

  .directive('reportViewDetailsTab', () => {
    return {
      restrict: 'E',
      template: detailsTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $filter,
                   $state,
                   utils,
                   config,
                   ToastsService,
                   I18nService,
                   ViewReportDataProvider) => {

        const $t = $filter('translate');
        const locale = I18nService.getLocale()?.code || 'en';

        const dataProvider = ViewReportDataProvider.instance;
        $scope.dataProvider = dataProvider;

        const isGlobalReport = dataProvider.isGlobalReport;
        const paramTypes = {
          1: 'string',
          2: 'number',
          3: 'date',
          4: 'number',
          5: 'boolean'
        };

        $scope.params = {};
        $scope.loading = false;
        $scope.initialLoading = true;
        $scope.report = angular.copy(dataProvider.reportResource.value);
        $scope.orgInfo = dataProvider.orgInfo;
        $scope.allOrgs = dataProvider.allOrgs;
        $scope.organizations = dataProvider.organizations;
        $scope.timezone = moment.tz.guess() || 'GMT';

        $scope.dateOptions = config.getConfigByKey('dateOptions');
        $scope.periods = config.getConfigByKey('periods');

        // Form validation rules
        $.fn.form.settings.rules.integerOrEmpty = function(value, n) {
          if (!value || value == '') {
            return true;
          } else if (parseInt(value) < 0 || parseInt(value) == 0) {
            return false;
          }
          return $.fn.form.settings.rules.integer(value, n);
        };

        angular.extend($scope, {
          generateReport: generateReport,
          initForm: initForm,
          back: () => dataProvider.goBack(),
        });

        // Remove modals
        $scope.$on('$destroy', () => {
          $('#approve-email-dialog').remove();
        });

        init();

        function init() {
          $scope.initialLoading = true;
          prepareReportParamsConfigs()
            .then(() => {
              $scope.initialLoading = false;
            })
            .catch((err) => {
              $scope.initialLoading = false;
              if (err) {
                console.warn(err);
              }
            });
        }

        function initForm() {
          // Custom rule for datepickers to check required date only when "exactDate" dropdown selected
          $.fn.form.settings.rules.emptyDateChecker = (value, paramId) => {
            let paramConfig = $scope.paramConfigs.find(p => p.id === paramId);
            if (paramConfig && paramConfig.dateOption && paramConfig.dateOption !== 'exactDate') {
              return true;
            }
            return !!value;
          };

          let fields = {};
          $scope.paramConfigs.forEach(param => {
            fields[param.id] = {};

            if (param.type === 'date' && param.required) {
              fields[param.id].rules = [
                {
                  type: `emptyDateChecker[${param.id}]`,
                  prompt: $t('reports.errors.paramRequired')
                }
              ];
            } else if (param.required) {
              fields[param.id].rules = [
                {
                  type: 'empty',
                  prompt: $t('reports.errors.paramRequired')
                }
              ];
            }

            // Validate number fields
            if (param.type === 'number' || param.type === 'integer') {
              fields[param.id].rules = [
                {
                  type: param.required ? 'integer[1..999999]' : 'integerOrEmpty',
                  prompt: $t('reports.errors.paramNumber')
                }
              ];
            }

          });

          $('#report-params').form({
            inline: true,
            fields: fields
          });
        }

        function prepareReportParamsConfigs() {
          $scope.paramConfigs = [];
          let promises = [];
          let timezoneInserted = false;

          if (!$scope.report || !$scope.report.params) {
            return $q.resolve();
          }
          for (let i = 0; i < $scope.report.params.length; i++) {
            let param = detectParamType($scope.report.params[i]);
            let config = angular.copy(param, {});

            // Organization ID
            if (param.id === 'organizationId') {
              if (isGlobalReport || $scope.organizations.length > 1) {
                config.type = 'select';
                config.placeholder = $t('reports.view.placeholders.organization');
                config.values = isGlobalReport ? $scope.allOrgs : angular.copy($scope.organizations);
                $scope.params['organizationId'] = $scope.organizations[0].id;
                $scope.paramConfigs.push(config);
              } else if ($scope.orgInfo) { // Set current and hide from UI
                $scope.params['organizationId'] = $scope.orgInfo.id;
              }

            // Organization Domain Name
            } else if (param.id === 'orgDomain') {
              if (isGlobalReport) {
                config.type = 'string';
                config.placeholder = $t('reports.view.placeholders.domain');
                $scope.paramConfigs.push(config);
              } else if ($scope.orgInfo) { // set current and hide from UI
                $scope.params['orgDomain'] = $scope.orgInfo.domainName;
              }

            // Device Type
            } else if (param.id === 'deviceType') {
              config.type = 'select';
              config.placeholder = $t('reports.view.placeholders.device');
              config.values = [];

              const promise = dataProvider.getDeviceTypes()
                .then(deviceTypes => {
                  for (let j = 0; j < deviceTypes.length; j++) {
                    let deviceType = deviceTypes[j];
                    config.values.push({
                      id: deviceType.id,
                      name: deviceType.name
                    });
                  }
                });

              promises.push(promise);
              $scope.paramConfigs.push(config);

            // Period
            } else if (param.id === 'period') {
              config.type = 'select';
              config.values = $scope.periods;
              config.desc = $t('reports.view.periodDesc');
              $scope.paramConfigs.push(config);

            } else if (param.type === 'date') {
              // Insert timezone select if at least one date picker exists
              // We need to remove `syntheticTimezone` during saving
              if (!timezoneInserted) {
                const timezoneParamConfig = {
                  id: 'syntheticTimezone',
                  type: 'select',
                  placeholder: $t('reports.view.timezone.placeholder'),
                  name: $t('reports.view.timezone.name'),
                  required: true,
                  values: []
                };
                $scope.paramConfigs.push(timezoneParamConfig);

                const promise = dataProvider.getTimezones()
                  .then(timezones => {
                    if (timezones && timezones.length > 0) {
                      timezoneParamConfig.values = timezones;

                      // Check if the local browser timezone is present in the list of timezones
                      let currentTz = timezones.find(tz => tz.id === $scope.timezone);
                      if (!currentTz) {
                        const tzInfo = moment.tz($scope.timezone);
                        currentTz = {
                          id: $scope.timezone,
                          offset: tzInfo.utcOffset(),
                          dst: tzInfo.isDST(),
                          name: $scope.timezone
                        };
                        timezoneParamConfig.values.unshift(currentTz);
                      }
                      $scope.params['syntheticTimezone'] = currentTz.id;
                    } else {
                      $scope.paramConfigs = $scope.paramConfigs.filter(p => p.id !== 'syntheticTimezone');
                    }
                  }, () => {
                    $scope.paramConfigs = $scope.paramConfigs.filter(p => p.id !== 'syntheticTimezone');
                  });
                promises.push(promise);

                timezoneInserted = true;
              }

              // Datetime parameter type
              // Add datepicker config for date params (we need a new object for every datepicker)
              config.datePickerParams = getDatePickerParams(config);
              config.dateOption = 'exactDate';
              $scope.paramConfigs.push(config);
            } else {
              $scope.paramConfigs.push(config);
            }
          }

          return $q.all(promises);
        }

        function getDatePickerParams(paramConfig) {
          return {
            language: locale,
            position: 'bottom left',
            view: 'days',
            minView: 'days',
            autoClose: true,
            dateFormat: 'm/dd/yyyy',
            timepicker: true,
          };
        }

        function detectParamType(config) {
          config.type = paramTypes[config.type] || null;
          return config;
        }

        function generateReport() {
          $('#report-params').form('validate form');
          if (!$('#report-params').form('is valid')) {
            return;
          }

          let params = collectParamsForApiCall();
          params = angular.extend(params, {
            reportId: $scope.report.id,
            deliveryType: 3 // Execute and save
          });

          $scope.loading = true;
          dataProvider.generateReport(params)
            .then((response) => {
              $scope.loading = false;
              ToastsService.success(null, $t('reports.errors.reportGenerationSuccess'));

              // Report runs asynchronously and returns a token. Start polling for its
              // completion and move the user to the history tab where the loader shows.
              if (response && response.token) {
                dataProvider.startReportPolling(response.token);
                dataProvider.activeTab = 'history';
              }
            })
            .catch((err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function collectParamsForApiCall() {
          let params = angular.copy($scope.params) || {};

          const selectedTimezoneId = params['syntheticTimezone'] || $scope.timezone;
          delete params['syntheticTimezone'];

          $scope.paramConfigs.forEach(paramConfig => {
            if (paramConfig.type === 'date') {
              if (paramConfig.dateOption !== 'exactDate') {
                params[paramConfig.id] = paramConfig.dateOption;
              } else if (angular.isDate(params[paramConfig.id])) {
                params[paramConfig.id] = forceApplyTimezone(params[paramConfig.id], selectedTimezoneId);
              }
            }
          });

          return params;
        }

        /**
         * Force apply timezone for native JS date preserving the actual date and time, and format as ISO string
         * @param {Date} date sate that was set obviously in current browser timezone
         * @param {string} realTimezone real timezone ID that should be used
         * @return {string} ISO date string
         */
        function forceApplyTimezone(date, realTimezone) {
          return moment.tz([
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds()
          ], realTimezone).toISOString();
        }

      }
    };
  })
  .name;
